$('document').ready(function(){
  $('#checkboxes input[type="checkbox"]').on('change', function () {
    select_elem_id = $(this).data('selectid');
    select_elem = document.getElementById(select_elem_id);

    select_elem_val =  (select_elem.value == "") ? [] : select_elem.value.split(', '); 
    
    if (this.checked) {
      select_elem_val.push(this.value);
    } else {

      index = select_elem_val.indexOf(this.value);
      if (index > -1){
        select_elem_val.splice(index, 1);
      }
    }
    
    select_elem.value = select_elem_val.join(', ');
    
  });
  
});

var expanded = false;

function showCheckboxes() {
  var checkboxes = document.getElementById("checkboxes");
  if (!expanded) {
    checkboxes.style.display = "block";
    offsetCalculate();
    expanded = true;
  } else {
    checkboxes.style.display = "none";
    expanded = false;
  }
}

function offsetCalculate(){
  var parent_position = $('#multiselect-container').offset();
  var offsets =  document.getElementById('multiselect-container').getBoundingClientRect();
  $('#checkboxes').offset({
    'top':parent_position.top + offsets.height,
    'left': parent_position.left
  });
  $('#checkboxes').css('width', offsets.width);
}

$(window).resize(function(){
  if (expanded)
    offsetCalculate();
});